import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    serviceProviderSubscriptions: {},
    selectedSubscriptionPlanDetails: {},
    serviceProviderSubscriptionPlanHistory:{},
    serviceProviderOrganizationSponsorshipHistory:{},
    serviceProviderPushNotificationHistory:{}
};


const serviceProviderSubscriptions = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case Actions.GET_SERVICE_PROVIDER_SUBSCRIPTIONS_LIST: {
      draft.serviceProviderSubscriptions = payload?.serviceProviderSubscriptions;
    }

    case Actions.GET_SERVICE_PROVIDER_SUBSCRIPTION_PLAN_HISTORY_LIST: {
      draft.serviceProviderSubscriptionPlanHistory = payload?.serviceProviderSubscriptionPlanHistory;
    }

    case Actions.GET_SERVICE_PROVIDER_ORGANIZATION_SPONSORSHIP_HISTORY_LIST: {
      draft.serviceProviderOrganizationSponsorshipHistory = payload?.serviceProviderOrganizationSponsorshipHistory;
    }

    case Actions.GET_SERVICE_PROVIDER_PUSH_NOTIFICATION_HISTORY_LIST: {
      draft.serviceProviderPushNotificationHistory = payload?.serviceProviderPushNotificationHistory;
    }

    case Actions.SELECTED_SUBSCRIPTION_PLAN_DETAILS: {
      draft.selectedSubscriptionPlanDetails = payload?.selectedSubscriptionPlanDetails;
    }

    default: {
      break;
    }
  }
}, initialState);

export default serviceProviderSubscriptions;
